<template>
  <v-layout>
    <v-flex v-for="(o, i) in items" :key="i" style="text-align:center;">
      <v-card>
        <i :class="'icon fa-3x '+o.icon"></i>
        <h3>{{o.title}}</h3>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    // diferenciais usando ícones
    items: [
      { title: "Pensado para o convívio e interação", icon: "fas fa-heart" },
      { title: "Oferece conforto e segurança", icon: "fas fa-shield-alt" },
      {
        title: "Arborizado e permite o contato com a natureza",
        icon: "fas fa-tree"
      },
      {
        title: "Salas climatizadas e bem equipadas",
        icon: "fas fa-snowflake"
      },
      {
        title: "Favorece o estudo e o aprendizado",
        icon: "fas fa-chalkboard-teacher"
      },
      { title: "Sempre limpo e bem arejado", icon: "fas fa-sun" },
      {
        title: "Atenção especial para a acessibilidade",
        icon: "fas fa-wheelchair"
      },
      {
        title: "Localização privilegiada no bairro Campeche",
        icon: "fas fa-map-marker-alt"
      }
    ]
  })
};
</script>

<style lang="scss" scoped>
p {
  text-align: center;
}

.icon {
  // color: rgba(255, 255, 255, 0.5);
}

h3 {
  // color: #ffffff;
  margin: 5px 0 30px 0;
  font-size: 1.2em;
  line-height: 1.2em;
}
</style>
